import CustomerGrowerModel from '@/models/crm/CustomerGrowerModel'
import CrmServiceCollection from '@/collections/CrmServiceCollection'

/**
 * Customer Grower collection
 */
export default class CustomerGrowerCollection extends CrmServiceCollection {

  // Model that is contained in this collection.
  model () {
    return CustomerGrowerModel
  }

}
